import classnames from "classnames"
import { FC, SVGProps, useEffect, useSyncExternalStore } from "react"
import "./icon-styles.less"
import { getIcon, getIconsVersion, loadPlatformIcons, subscribeToIcons } from "./iconRegistry"

export type IconTypes =
  | "zip"
  | "rotate-orbit"
  | "payments"
  | "green-tick"
  | "user-square"
  | "user-group"
  | "collage"
  | "library"
  | "folders"
  | "support-regular"
  | "support-filled"
  | "location-item"
  | "approvals"
  | "documents"
  | "arrow-up-90"
  | "building"
  | "checked-square"
  | "eye"
  | "result-item"
  | "pdf-logo"
  | "arrow-right-orange"
  | "clock-circle"
  | "warning-circle"
  | "check-circle"
  | "plus-white"
  | "bell"
  | "process-item"
  | "process-badge"
  | "dashed-line"
  | "hexagon-arrow"
  | "hexagon-btn"
  | "split-arrow"
  | "popup-btn"
  | "popup-close"
  | "footer-soc-btn"
  | "project-info"
  | "collapse-expand"
  | "manager-reports"
  | "agent-template"
  | "professional-template"
  | "government-template"
  | "service-template"
  | "sidebar-user-overview-main"
  | "logo"
  | "sidebar-folder"
  | "sidebar-compass"
  | "sidebar-clipper"
  | "sidebar-tickBox"
  | "sidebar-bag"
  | "sidebar-barchart"
  | "sidebar-overview"
  | "sidebar-projects"
  | "sidebar-applications"
  | "sidebar-government"
  | "sidebar-companies"
  | "settings"
  | "down"
  | "notification-menu"
  | "table-view-switcher"
  | "grid-view-switcher"
  | "magnifying-glass"
  | "magnifying-glass-gray"
  | "arrow-left"
  | "arrow-right"
  | "arrow-scroll-up"
  | "arrow-back"
  | "read-more-arrow-right"
  | "cross"
  | "esc"
  | "calendar"
  | "no-notifications"
  | "close-modal"
  | "app-create-close"
  | "app-create-details"
  | "app-create-location"
  | "app-create-upload"
  | "app-create-tick"
  | "refresh"
  | "bin"
  | "expand-zoom"
  | "doc"
  | "download"
  | "image-gray"
  | "clip"
  | "plus"
  | "success-tick"
  | "tick-info-card"
  | "clipper-info-card"
  | "small-white-tick"
  | "notification-image"
  | "notification-clip"
  | "notification-clip-2"
  | "notification-smile"
  | "checked"
  | "unchecked"
  | "clip-providers"
  | "clip-providers-empty"
  | "logo-blue"
  | "logo-company-name"
  | "logo-dark-blue"
  | "logo-dark-blue-flipped"
  | "doc-sheet"
  | "yellow-folder"
  | "double-gray-dots"
  | "envelop"
  | "small-envelop"
  | "pencil"
  | "professionals-list"
  | "arrow-up-down"
  | "agent-info-overview"
  | "agent-applications-overview"
  | "agent-tasks-overview"
  | "bookmark-star"
  | "bookmark-star-active"
  | "bookmark-star-primary"
  | "close-notification"
  | "project-marker"
  | "manager-map"
  | "easetech"
  | "logo-company-name-dark"
  | "logo-easetech-dark"
  | "logo-easetech-white"
  | "map-pin-drop"
  | "map-aoi-pin-drop"
  | "enf-pin-drop"
  | "website-benefit-01"
  | "website-icon-hexagon"
  | "website-service-card-button"
  | "website-service-arrow-right"
  | "website-slider-arrow-right"
  | "website-slider-arrow-left"
  | "website-slider-hex-button"
  | "expand-arrow-down"
  | "expand-arrow-up"
  | "slider-settings"
  | "alarm"
  | "approved-doc"
  | "request-info"
  | "burger-icon"
  | "at"
  | "display"
  | "briefcase"
  | "question"
  | "transfer"
  | "envelop-open"
  | "chat-square"
  | "phone"
  | "whatsapp"
  | "doc-preview"
  | "image"
  | "plus-sm"
  | "client-centric"
  | "lamp-idea"
  | "money-circle"
  | "starred-award"
  | "thumb-up"
  | "timer"
  | "arrow-down-triangle"
  | "arrow-up-triangle"
  | "share"
  | "video-doc"
  | "expand"
  | "minimize"
  | "close"
  | "pencil-square"
  | "file-play"
  | "save"
  | "camera"
  | "doc-file"
  | "exclamation-square"
  | "exit"
  | "clock"
  | "watch"
  | "info-item"
  | "details"
  | "tick-square-approval"
  | "calendar-2"
  | "binocular"
  | "chat-message"
  | "box-arrow-in"
  | "app-approved"
  | "app-pending"
  | "circle-tick"
  | "circle-exclamation"
  | "check-list-item"
  | "info-square"
  | "sort-up"
  | "sort-down"
  | "approvals-pending"
  | "approvals-approved"
  | "settings-bold"
  | "clipboard-check"
  | "call-center"
  | "cell-house"
  | "plane-route"
  | "wrench-gear"
  | "exclamation-triangle"
  | "server"
  | "dots"
  | "eye-slash"
  | "trash"
  | "check-all"
  | "info-circle"
  | "three-dots"
  | "folder-arrow"
  | "archive"
  | "free"
  | "upload-in-color"
  | "green-ticked"
  | "button-plus"
  | "button-minus"
  | "circled-tick"
  | "user-guide"
  | "license"
  | "file-excel"
  | "telegram"
  | "table"
  | "excel-logo"
  | "pdf-doc-icon"
  | "kml"
  | "json"
  | "tiff"
  | "docx"
  | "image-placeholder"
  | "upload-icon"
  | "paper-details"
  | "location-mark"
  | "long-right-arrow"
  | "long-left-arrow"
  | "calendar-all"
  | "user-guide-note"
  | "tick"
  | "tick-in-square"
  | "empty-triangle-arrow-up"
  | "empty-triangle-arrow-down"
  | "play"
  | "headphones"
  | "google"
  | "time-duration"
  | "envelop-in-color"
  | "envelope-with-lock"
  | "blue-tick"
  | "green-tick-in-circle"
  | "exclamation"
  | "auto-approval-badge"
  | "envelope-upload"
  | "aoi"
  | "location-2"
  | "documents-2"
  | "upload-arrow"
  | "square-links"
  | "copy-file"
  | "confirm-delivery"
  | "no-response"
  | "review-delivery"
  | "photo-camera"
  | "checked-list"
  | "big-green-tick"
  | "big-red-x"
  | "user"
  | "profile"
  | "lock"
  | "security"
  | "emails"
  | "whatsapp-new"
  | "eye-up"
  | "little-cross"
  | "eye-frame"
  | "three-dots-vertical"
  | "users"
  | "expand-mode"
  | "collapse-mode"
  | "eye-broken"
  | "clipboard-check-with-search"
  | "black-long-left-arrow"
  | "black-long-right-arrow"
  | "dotted-menu"
  | "orange-circles"
  | "emergency-alert"
  | "map-pinned-geometry"
  | "attach-arrow-right"

export type IconColor =
  | "primary-blue"
  | "gray"
  | "black"
  | "light-gray"
  | "white"
  | "red"
  | "white-stroke"
  | "primary-blue-stroke"
  | "text-stroke"
  | "orange"
  | "light-blue"
  | "green"
  | "original"
  | "website-secondary"
  | "map-blue"
type SvgIconProps = SVGProps<SVGSVGElement> & { type: IconTypes; color?: IconColor; circleColor?: IconColor }

/**
 * An icon by name. The public website's icons are part of the first download; the platform's (platformIcons.ts) arrive
 * with the dashboard, or on first use elsewhere, and the icon renders once they have.
 */
const SvgIcon: FC<SvgIconProps> = ({ type, color, circleColor, className, ...svgProps }) => {
  // The third argument is the snapshot for the build-time prerender (src/entry-prerender.tsx).
  useSyncExternalStore(subscribeToIcons, getIconsVersion, getIconsVersion)
  const Icon = getIcon(type)
  useEffect(() => {
    if (!Icon) void loadPlatformIcons()
  }, [Icon])
  const classes = classnames("svg-icon", color, `circle-${circleColor}`, className)
  return Icon ? <Icon {...svgProps} className={classes} /> : null
}

export { SvgIcon }
